import {CustomTimingContextProvider} from '../../context/CustomTimingContextProvider';
import OnBoardingMain from './components/OnBoardingMain';

function OnBoarding() {
  return (
    <CustomTimingContextProvider>
      <OnBoardingMain />
    </CustomTimingContextProvider>
  );
}

export default OnBoarding;
